import {
    IComposition,
    ICustomProfileFieldOption,
    ILookupItem,
    IDrawing,
} from "common.ui/CustomForms/Editor/DataTypes/IStore";
import { CountryCode, Mode } from "common.ui/CustomForms/Editor/DataTypes/dataTypes";

export enum AuthenticationMethod {
    None,
    Email,
    MobileNumber,
}

export enum LockStatus {
    Locked = 0,
    Draft = 1,
    AutoDraft = 2,
}

export enum FormState {
    Dirty = "Dirty",
    Saving = "Saving",
    Saved = "Saved",
}

export interface ICompositionParams {
    templateId: number;
    customFormId: number;
    composition: IComposition;
    drawingsAvailable: IDrawing[];
    formType: number;
    status: LockStatus;
    defaultMode: Mode;
    isPortalCustomFormView?: boolean;
    displayModes?: boolean;
    uploadClientFilesUrl: string;
    clientFileMaxNumber: number;
    clientFileMaxSize: number;
    clientFileAllowedExtensions: string[];
    lookups: Map<string, ILookupItem[]>;
    customLookups: Map<string, ILookupItem[]>;
    customProfileFields?: ICustomProfileFieldOption[];
    sgCountryCode: CountryCode;
    bsDateFormat: string;
    bsWeekStart: number;
    shortDateFormat: string;
}
